import storage from '@/utils/browser/storage'
import { httpRequest } from '@/services/http'

const _getWhatsappLink = async () => {
  const response = await httpRequest({
    url: `/whatsapp_link/`,
    options: { method: 'GET' }
  })

  if (response.error) {
    const error = new Error()
    error.message = response.message
    error.status = response.status
    throw error
  }

  return response
}

export default {
  get: _getWhatsappLink
}
